import { render, staticRenderFns } from "./SfCircleIcon.vue?vue&type=template&id=5803ce72&functional=true"
import script from "./SfCircleIcon.vue?vue&type=script&lang=js"
export * from "./SfCircleIcon.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfCircleIcon.vue?vue&type=style&index=0&id=5803ce72&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  "2c6a0dc7"
  
)

export default component.exports